export default __webpack_public_path__ + "static/media/1368.9607cf98.png";